import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ServicesSection from './components/ServicesSection';
import AIAnswerBlock from './components/AIAnswerBlock';
import ProcessSection from './components/ProcessSection';
import WhyChooseUs from './components/WhyChooseUs';
import StatsSection from './components/StatsSection';
import ServiceAreas from './components/ServiceAreas';
import Testimonials from './components/Testimonials';
import FAQSection from './components/FAQSection';
import MapContact from './components/MapContact';
import FinalCTA from './components/FinalCTA';

const HomePage = () => {
  return (
    <div className="font-body" style={{ fontFamily: '"Inter", sans-serif' }}>
      <Header />
      <main>
        <HeroSection />
        <TrustBar />
        <ServicesSection />
        <AIAnswerBlock />
        <ProcessSection />
        <WhyChooseUs />
        <StatsSection />
        <ServiceAreas />
        <Testimonials />
        <FAQSection />
        <MapContact />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
